import React, { useState, useEffect, useRef } from "react";
import "./styles.css";

// check out the Medium writeup: https://medium.com/@toshvelaga/recording-video-in-the-browser-using-the-mediarecorder-api-c78914ebc401

export default function App() {
  const [isActive, setIsActive] = useState(false);
  const [userFacing, setuserFacing] = useState(true);
  const [videoUrl, setvideoUrl] = useState("");
  const [chunks, setchunks] = useState([]);

  const videoRef = useRef();
  var mediaRecorder = useRef();
  let liveStream;
  var tempStream = new MediaStream();

  const CAPTURE_OPTIONS = {
    audio: true,
    video: true
  };

  useEffect(() => {
    camera();
    videoRef.current.srcObject = tempStream.remoteStream;
  }, []);

  async function screen() {
    const stream = await navigator.mediaDevices.getDisplayMedia(
      CAPTURE_OPTIONS
    );
    stream.replaceVideoTrack(stream.getVideoTracks()[0]);
  }

  async function camera() {
    const stream = await navigator.mediaDevices.getUserMedia(CAPTURE_OPTIONS);
    stream.replaceVideoTrack(stream.getVideoTracks()[0]);
    stream.replaceAudioTrack(stream.getAudioTracks()[0]);
  }

  const startRecording = () => {
    liveStream = videoRef.current.captureStream(30); // 30 FPS
    const options = {
      mimeType: "video/webm;codecs=h264",
      videoBitsPerSecond: 3 * 1024 * 1024
    };
    mediaRecorder.current = new MediaRecorder(liveStream, options);
    mediaRecorder.current.ondataavailable = (e) => {
      chunks.push(e.data);
      console.log("send data", e.data);
    };
    mediaRecorder.current.start(1000);
  };

  const stopRecording = () => {
    mediaRecorder.current.stop();

    const recVideoBlob = new Blob(chunks, {
      type: "video/webm;codecs=h264"
    });
    const videoURL = window.URL.createObjectURL(recVideoBlob);
    setvideoUrl(videoURL);
  };

  // toggles the stream to active or inactive
  const toggle = () => {
    setIsActive(!isActive);
  };

  const toggleRecording = () => {
    !isActive ? startRecording() : stopRecording();
    toggle();
  };

  const toggleScreenSharing = () => {
    userFacing ? screen() : camera();
    setuserFacing(!userFacing);
  };

  return (
    <div className="studio-container">
      <div id="container">
        <video
          width="640px"
          height="480px"
          ref={videoRef}
          autoPlay
          playsInline
          muted={true}
        />
        {/* VIDEO WILL APPEAR OF RECORDING AFTER PRESSING STOP RECORDING */}
        <div>
          {videoUrl ? (
            <video width="640px" height="480px" controls src={videoUrl} />
          ) : null}
        </div>
      </div>
      <div className="studio-bottom-button-container">
        <button onClick={toggleRecording}>
          {!isActive ? "Go Live" : "Stop Recording"}
        </button>
        {/* <button onClick={stopRecording}>Stop Record</button> */}
        <button onClick={toggleScreenSharing}>
          {userFacing ? "Share Screen" : "Stop Sharing"}
        </button>
      </div>
    </div>
  );
}
